import React, { Component } from 'react';

import 'react-table/react-table.css';

import { postManualLease } from 'actions/landlordTenantsActions';
import { displayLoader } from 'actions/notificationActions';
import { showCotenantsForm, hideCotenantsForm } from 'actions/tenantApplicationActions';
import {
  getProperties,
  getUnits,
  getCurrentLeasesOfUnit,
  clearCurrentLeasesOfUnit,
} from 'actions/landlordPropertiesActions';

import ManualLeaseCreatorForm from './components/manual_lease_creator/manualLeaseCreatorForm';
import FooterButtons from 'components/shared/FooterButtons';

import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { destroy } from 'redux-form';

export default connect(
  store => ({
    showPage: store.authentication.showPage,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    displayCotenantsForm: store.tenantApplication.showCotenantsForm,
    currentLeasesOfUnit: store.landlordProperties.currentLeasesOfUnit,
  }),
  {
    postManualLease,
    showCotenantsForm,
    hideCotenantsForm,
    getProperties,
    getUnits,
    getCurrentLeasesOfUnit,
    clearCurrentLeasesOfUnit,
    destroy,
    displayLoader,
  }
)(
  class ManualLeaseCreator extends Component {
    componentDidMount = () => {
      this.props.getProperties({ for_multiselect: true });
      this.props.hideCotenantsForm();
      this.props.clearCurrentLeasesOfUnit();
    };

    submitLease = values => {
      this.props.displayLoader('create your lease');
      this.props.postManualLease(values);
    };

    goToRentRollPage = () => {
      this.props.destroy('manual_lease_creator_form');
      browserHistory.push('/companies/rent_roll');
    };

    render() {
      const formPageProps = {
        name: 'manual_lease_creator_form',
      };

      return (
        <div className="body" role="main">
          {this.props.properties &&
            this.props.showPage && (
              <div className="centers">
                <div>
                  <div
                    style={{
                      maxWidth: '750px',
                      height: '100%',
                      overflow: 'hidden',
                      paddingRight: '15px',
                      paddingLeft: '15px',
                      marginRight: 'auto',
                      marginLeft: 'auto',
                    }}
                  >
                    <div className="row">
                      <CSSTransitionGroup
                        transitionName="fade_out"
                        transitionEnterTimeout={200}
                        transitionAppear={true}
                        transitionAppearTimeout={500}
                        transitionLeaveTimeout={200}
                      >
                        <ManualLeaseCreatorForm
                          {...formPageProps}
                          previousPage={this.goToRentRollPage}
                          properties={this.props.properties}
                          units={this.props.units}
                          getUnits={getUnits}
                          showCotenantsForm={this.props.showCotenantsForm}
                          hideCotenantsForm={this.props.hideCotenantsForm}
                          displayCotenantsForm={this.props.displayCotenantsForm}
                          onSubmit={this.submitLease}
                          currentLeasesOfUnit={this.props.currentLeasesOfUnit}
                          getCurrentLeasesOfUnit={this.props.getCurrentLeasesOfUnit}
                          clearCurrentLeasesOfUnit={this.props.clearCurrentLeasesOfUnit}
                        />
                      </CSSTransitionGroup>
                    </div>
                  </div>
                  <div style={{ height: '170px' }} />
                </div>
                <FooterButtons
                  submit={this.submitLease}
                  formName="manual_lease_creator_form"
                  submitName="SAVE"
                  backAction={this.goToRentRollPage}
                />
              </div>
            )}
        </div>
      );
    }
  }
);
